import styled from 'styled-components'

import { ProfileActivePositionsTable } from '@root/features/trade/position/profile-positions-table/ui/profile-positions-table'

import type { DelugeId } from '@root/entities/user-short'

type Props = {
  delugeId: DelugeId
}

export const ProfilePositionsView: React.FC<Props> = ({ delugeId }) => {
  return (
    <Root>
      <ProfileActivePositionsTable delugeId={delugeId} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  height: 100%;
  padding-top: 20px;
`
